import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";

const ENDPOINT = "/log_analysis/analyze_now";

export class AnalyzeLogNowCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: AnalyzeLogNowReqData = null;

    constructor(params: AnalyzeLogNowReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<ServiceResponseData> {
        let res = await this.executeCommand(null, null, this.params);
        return new ServiceResponseData(res);
    }
}

export class AnalyzeLogNowReqData {
    installationName: string = null;
    startDate: Date;
    endDate: Date;
    constructor(installationName: string, startDate: Date, endDate: Date) {
        this.installationName = installationName;
        this.startDate = startDate;
        this.endDate = endDate;
    }
}
